import React from 'react'
import styles from './styles.module.css'

function Button({ children, color, onClick }) {
  return (
    <button className={styles.button} style={{background: color}} onClick={onClick}>{children}</button>
  )
}

export default Button